import { Alert, HazardType, LatLng } from "../types";
import { getHazardImage } from "./disasterService";
import { fetchTomTomIncidents } from "./tomtomService";

// Helper to interpolate points along a line (Road Simulation)
const interpolatePoints = (start: LatLng, end: LatLng, count: number): LatLng[] => {
    const points: LatLng[] = [];
    for (let i = 0; i < count; i++) {
        const t = i / (count - 1);
        points.push({
            lat: start.lat + (end.lat - start.lat) * t,
            lng: start.lng + (end.lng - start.lng) * t
        });
    }
    return points;
};

/**
 * Generate fallback simulated traffic data
 */
const generateSimulatedTraffic = (userLoc: LatLng): Alert[] => {
    const alerts: Alert[] = [];

    // Simulate traffic near user location
    const startPoint = { lat: userLoc.lat + 0.01, lng: userLoc.lng };
    const endPoint = { lat: userLoc.lat - 0.01, lng: userLoc.lng };

    // Generate 5 cars along the road
    const roadPoints = interpolatePoints(startPoint, endPoint, 5);

    roadPoints.forEach((pt, i) => {
        const laneJitter = (Math.random() * 0.0001) - 0.00005;

        alerts.push({
            id: `traffic-sim-${i}-${Date.now()}`,
            type: HazardType.TRAFFIC,
            severity: i % 3 === 0 ? 'high' : 'medium',
            location: 'Local Road',
            coordinates: { lat: pt.lat, lng: pt.lng + laneJitter },
            timestamp: new Date().toISOString(),
            time: 'Live',
            distance: '0.2km',
            isOfficial: false,
            source: 'Simulation (TomTom unavailable)',
            truthScore: 70,
            description: `Simulated traffic flow. Density: ${85 + (i * 2)}%.`,
            advice: ['Check TomTom for live traffic data'],
            imageUrl: getHazardImage(HazardType.TRAFFIC)
        });
    });

    return alerts;
};

/**
 * Fetch traffic incidents - Try TomTom first, fallback to simulation
 */
export const fetchTrafficIncidents = async (userLoc: LatLng): Promise<Alert[]> => {
    try {
        // Try TomTom API first
        console.log('🚗 Fetching traffic from TomTom...');
        const tomtomIncidents = await fetchTomTomIncidents(userLoc, 30);

        if (tomtomIncidents.length > 0) {
            console.log(`✅ Got ${tomtomIncidents.length} TomTom traffic incidents`);
            return tomtomIncidents;
        }

        // If no incidents from TomTom, return empty (area might just be clear)
        console.log('ℹ️ No TomTom incidents - area may be clear');
        return [];

    } catch (error) {
        console.warn('⚠️ TomTom API failed, using simulated data:', error);
        // Fallback to simulated data
        await new Promise(resolve => setTimeout(resolve, 300));
        return generateSimulatedTraffic(userLoc);
    }
};

export default { fetchTrafficIncidents };
